import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { JwtAuthService } from "../services/auth/jwt-auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError } from "rxjs/operators";
import { AppConfirmService } from './../services/app-confirm/app-confirm.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private jwtAuth: JwtAuthService, private appConfirmService: AppConfirmService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // req.url.
    const re = 'viacep.com.br/ws';
    const r2 = '/receitaws/';

    // Exclude interceptor for login request:
    if (req.url.search(re) > -1 || req.url.search(r2) > -1) {
      return next.handle(req);
    }
    const correiosSoap = '/calculador/';
    if (req.url.search(correiosSoap) > -1) {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'xml/text');
      req.clone({ headers: headers });
      return next.handle(req);
    }


    //  const loja$ = this.jwtAuth.getLojaSeleted$();
    //  const authReq = req.clone({headers:
    //      (loja$ != null &&  loja$.getValue() != null &&
    //      req.url.search(loja$.getValue().url_api) > -1 ) ? this.getHeadersLoja() :  this.getHeaders()});
    //   console.log('COLOCANDO TOKEN:' + localStorage.getItem('token') + '\n na CHAMADA' + req.url );



    var token = this.jwtAuth.token || this.jwtAuth.getJwtToken();
    // console.log('ITEM EM REQ:' + JSON.stringify(this.jwtAuth.item$?.value) + '\n na CHAMADA' + req.url );

    if (this.jwtAuth.item$?.value?.remoto && this.jwtAuth.item$?.value?.empresaRemota !== null
      && this.jwtAuth.item$?.value?.empresaRemota !== undefined && req.url.search(this.jwtAuth.item$?.value?.empresaRemota.urlApi) > -1) {
      token = this.jwtAuth.tokenRemoto || this.jwtAuth.getJwtTokenRemoto();
      // console.log('COLOCANDO TOKEN:' + token + '\n na CHAMADA' + req.url );
    }
    var changedReq;

    if (token) {

      changedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
      });

    } else {

      changedReq = req;
    }



    return next.handle(changedReq).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 403) {
      this.appConfirmService.confirm({
        title: 'A T E N Ç Ã O !', message:
          'Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!', error: true
      })
      console.log('Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!');

      return of(err.message);

    } else if (err.status === 401) {

    }
    return throwError(err);
  }

 

 


}
